module.exports = __webpack_public_path__ + "static/media/estilosos_masculino_acessorios.93c0a84a.jpg";